// aiUsage / period — the period presets as concrete ranges, in the viewer's
// local time. Pure: the caller passes "now".
//
//   day    today
//   week   this week, Monday to today
//   month  this month, the 1st to today
//
// `to` is the start of tomorrow (exclusive), so today's calls are in.
// `last` is the last day inside the range, for labels.

export type { PeriodRange };
export { periodRange };

import type { PeriodPreset } from "./route.js";

type PeriodRange = {
    readonly from: Date;
    readonly to: Date;
    readonly last: Date;
};

const startOfDay = (d: Date): Date =>
    new Date(d.getFullYear(), d.getMonth(), d.getDate());

const addDays = (d: Date, n: number): Date =>
    new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);

const periodRange = (preset: PeriodPreset, nowMs: number): PeriodRange => {
    const today = startOfDay(new Date(nowMs));
    const from = (() => {
        switch (preset) {
            case "day":
                return today;
            case "week":
                // getDay(): 0 = Sunday; weeks start on Monday.
                return addDays(today, -((today.getDay() + 6) % 7));
            case "month":
                return new Date(today.getFullYear(), today.getMonth(), 1);
        }
    })();
    return { from, to: addDays(today, 1), last: today };
};
